module.exports = __webpack_public_path__ + "static/media/nav-menu.40ec5782.svg";